export type TypeRegistro = {
    codigo?: number,
    tipo?: string
}

export enum EnumRegistroTipo {
    Grupo = 1,
    Subgrupo = 2,
    Item = 3
}